<template>
    <span ref="component"></span>
</template>

<script>
    import vueCookies from 'vue-cookies';

    export default {
        props: {
            value: {default: 'treatment'},
            random: {default: '0'},
            trial: {default: '0'},
            min: {default: '0'},
            max: {default: '0'},
        },
        data() {
            return {}
        },
        computed: {},
        mounted() {
            if (this.random === '1') {
                const variable = `s-${this.trial}-${this.value}`;
                let randomNumber = vueCookies.get(variable);

                if (!randomNumber) {
                    const min = parseInt(this.min);
                    const max = parseInt(this.max);
                    randomNumber = Math.floor(Math.random() * (max - min + 1) + min);
                    vueCookies.set(variable, randomNumber, 60 * 60 * 24 * 365);
                    console.log({keep: {value: this.value, number: randomNumber}});
                } else {
                    console.log({keep_found: {value: this.value, number: randomNumber}});
                }

                const questionContainer = $(this.$refs.component).closest('.question-container');
                questionContainer.find('.form-control').val(randomNumber);
            }
        },
        methods: {},
        watch: {},
        components: {}
    }
</script>
